let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("HY4Vc")).then(() => parcelRequire('4ykQ2'));